<div class="hederText">General</div>
<div mat-dialog-content>
    <div style="padding-bottom: 20px;">
        <div style="padding-left: 20px;">
            <div><span class="titleName">Name: </span> {{name}}</div>
            <div><span class="titleName">Created:  </span>{{created}}</div>
            <div><span class="titleName">Last Saved: </span> {{lastSaved}}</div>
            <div><span class="titleName">Refinery: </span>{{refineryName}}</div>
            <!-- <p>Pipeline: {{subtitle}}</p> -->
            <div><span class="titleName">Node: </span><span [ngStyle]="{'color':farmTypeColor}" >{{description}}</span> </div>
            <div><span class="titleName">Node Type: </span>{{nodeType}}</div>
            <div><span class="titleName">{{transformerLabel}}:</span>
                <ul style="margin: 0px !important;">
                    <li *ngFor="let transformername of transformerlist">{{ transformername }}</li>
                </ul>
            </div>
            <div><span class="titleName">Input Farm Nodes: </span> {{ inputNode }}</div>
            <div><span class="titleName">Attribute Farm Nodes:</span> {{ inputAttr }} </div>
            
        </div>
    </div>
    <!-- <div [ngStyle]="{'color':farmTypeColor}" >{{description}}</div> -->
</div>

<div  class="hederText"> Last Run Statistics</div>
<div mat-dialog-content>
    <div>
        <div style="padding-left: 20px;">
            <div><span class="titleName">Last Run on: </span>{{lastRun}}</div>
            <div><span class="titleName">Result: </span><span [ngStyle]="{ 'color': NodeRunStatusUtil.statusColor(nodeStatus)}">{{NodeRunStatusUtil.toString(nodeStatus)}}</span></div>
            <div><span class="titleName">Rows in: </span>{{rowsIN | number}}</div>
            <div><span class="titleName">Rows Out: </span>{{rowsOut | number}}</div>
            <div><span class="titleName">Run Time: </span>{{runTime}}</div>
        </div>
    </div>
    
</div>

<mat-dialog-actions align="end">
    <button (click)="cancel()" mat-raised-button mat-dialog-close tabindex="-1">Close</button>
</mat-dialog-actions>
